<template>
  <el-dialog
    :title="$t('zlfk.scfj')"
    :visible.sync="dialogVisible"
    width="600px"
    @close="handleClose"
  >
    <div class="upload-container">
      <drag-upload
        ref="uploadFile"
        :accessoryList.sync="fileList"
        :httpRequest="uploadUrl"
        :tipStatus="false"
        :uploadTips="uploadTip"
      />
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button type="primary" @click="handleSave">{{ $t("seek.submit") }}</el-button>
      <el-button @click="handleClose">{{ $t("seek.cancel") }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import dragUpload from "@/components/fileUpload/dragUpload.vue";

export default {
  components: {
    dragUpload,
  },
  data() {
    return {
      dialogVisible: false,
      fileList: [],
      uploadUrl: "/customer/activity-claimant/upload",
      rowData: null,
      uploadTip: "",
    };
  },
  methods: {
    init() {
      this.dialogVisible = true;
      this.fileList = this.rowData && this.rowData.fileList ? [...this.rowData.fileList] : [];
      this.uploadTip =`<p>${this.$t("zlfk.tpzc")}</p><p>${this.$t("zlfk.spzc")}</p>`
    },
    handleClose() {
      this.dialogVisible = false;
      this.$refs.upload && this.$refs.upload.clearUploadingStatus();
    },
    handleSave() {
      this.$emit("save", this.fileList);
      this.handleClose();
    },
  },
};
</script>

<style scoped>
.upload-container {
  min-height: 200px;
}
.dialog-footer {
  text-align: center;
}
.tips {
  margin-top: 15px;
  padding: 10px;
  background: #f5f7fa;
  border-radius: 4px;
  font-size: 12px;
  color: #666;
}
.tips p {
  margin: 5px 0;
  line-height: 1.5;
}
.tips span {
  margin-left: 10px;
  color: #999;
}
</style>
